export default __webpack_public_path__ + "static/media/business-05.39898e1e.jpg";